import React from "react";
import ContentLoader from "react-content-loader";
import { Container } from "./styles";
import { FiPlus, FiSearch, FiSend, FiUsers } from "react-icons/fi";
import { HiOutlineCheckCircle, HiOutlineExclamationCircle } from "react-icons/hi";

const EmailMarketingLoadingSkeleton = ({ isDark = true }) => {
  const backgroundColor = isDark ? "#1a1a1a" : "#f0f0f0";
  const foregroundColor = isDark ? "#2a2a2a" : "#e5e7eb";

  const kpiIcons = [
    { Icon: FiSend, cls: "" },
    { Icon: HiOutlineCheckCircle, cls: "success" },
    { Icon: HiOutlineExclamationCircle, cls: "warning" },
    { Icon: FiUsers, cls: "info" },
  ];

  return (
    <Container>
      <div className="header-info">
        <div className="header-details">
          <h3 data-eyebrow="EMAIL MARKETING">Campanhas de Email</h3>
          <div className="header-meta">
            <span className="status-tag">SISTEMA ATIVO</span>
            <span className="update-tag">carregando campanhas</span>
          </div>
        </div>
      </div>

      <div className="tabs-header">
        <button className="tab active">Campanhas</button>
        <button className="tab">Lista de Emails</button>
      </div>

      <div className="kpi-cards">
        {kpiIcons.map((item, i) => {
          const { Icon, cls } = item;
          return (
            <div key={`kpi-${i}`} className={`kpi-card ${cls}`}>
              <div className="card-content">
                <div className="thumb"><Icon /></div>
                <div className="text">
                  <ContentLoader speed={2} width={48} height={28} backgroundColor={backgroundColor} foregroundColor={foregroundColor}>
                    <rect x="0" y="0" rx="4" ry="4" width="48" height="28" />
                  </ContentLoader>
                  <ContentLoader speed={2} width={120} height={10} backgroundColor={backgroundColor} foregroundColor={foregroundColor} style={{ marginTop: 4 }}>
                    <rect x="0" y="0" rx="3" ry="3" width="120" height="10" />
                  </ContentLoader>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="toolbar">
        <div className="toolbar-left">
          <button className="btn-new" style={{ opacity: 0.6 }}>
            <FiPlus />
            Nova Campanha
          </button>
          <div className="search-box">
            <FiSearch />
            <ContentLoader speed={2} width={200} height={14} backgroundColor={backgroundColor} foregroundColor={foregroundColor}>
              <rect x="0" y="0" rx="3" ry="3" width="200" height="14" />
            </ContentLoader>
          </div>
        </div>
        <div className="toolbar-right">
          <button className="filter-pill active">Todas</button>
          <button className="filter-pill">Rascunho</button>
          <button className="filter-pill">Enviada</button>
        </div>
      </div>

      <div className="main-content">
        <div className="campaign-grid">
          {[...Array(4)].map((_, i) => (
            <div key={`camp-${i}`} className={`campaign-card ${i % 2 === 0 ? "sent has-metrics" : "draft"}`}>
              <div className="campaign-head">
                <ContentLoader speed={2} width={38} height={38} backgroundColor={backgroundColor} foregroundColor={foregroundColor}>
                  <circle cx="19" cy="19" r="19" />
                </ContentLoader>
                <div className="campaign-top">
                  <span className="campaign-eyebrow">CRIADA · ··/··/····</span>
                  <ContentLoader speed={2} width={180} height={16} backgroundColor={backgroundColor} foregroundColor={foregroundColor}>
                    <rect x="0" y="0" rx="3" ry="3" width="180" height="14" />
                  </ContentLoader>
                  <ContentLoader speed={2} width={140} height={10} backgroundColor={backgroundColor} foregroundColor={foregroundColor} style={{ marginTop: 4 }}>
                    <rect x="0" y="0" rx="3" ry="3" width="140" height="10" />
                  </ContentLoader>
                </div>
                <ContentLoader speed={2} width={64} height={18} backgroundColor={backgroundColor} foregroundColor={foregroundColor}>
                  <rect x="0" y="0" rx="9" ry="9" width="64" height="18" />
                </ContentLoader>
              </div>

              <div className="campaign-tags-row">
                <ContentLoader speed={2} width={90} height={16} backgroundColor={backgroundColor} foregroundColor={foregroundColor}>
                  <rect x="0" y="0" rx="8" ry="8" width="90" height="16" />
                </ContentLoader>
                <div className="campaign-recipients">
                  <FiUsers />
                  <ContentLoader speed={2} width={80} height={10} backgroundColor={backgroundColor} foregroundColor={foregroundColor}>
                    <rect x="0" y="0" rx="3" ry="3" width="80" height="10" />
                  </ContentLoader>
                </div>
              </div>

              {i % 2 === 0 && (
                <div className="campaign-metrics">
                  {[0, 1, 2].map((m) => (
                    <div className="metric-block" key={m}>
                      <ContentLoader speed={2} width={70} height={10} backgroundColor={backgroundColor} foregroundColor={foregroundColor}>
                        <rect x="0" y="0" rx="3" ry="3" width="70" height="10" />
                      </ContentLoader>
                      <ContentLoader speed={2} width="100%" height={5} backgroundColor={backgroundColor} foregroundColor={foregroundColor} style={{ marginTop: 4 }}>
                        <rect x="0" y="0" rx="3" ry="3" width="100%" height="5" />
                      </ContentLoader>
                    </div>
                  ))}
                </div>
              )}

              <div className="campaign-actions-row">
                <ContentLoader speed={2} width="100%" height={32} backgroundColor={backgroundColor} foregroundColor={foregroundColor}>
                  <rect x="0" y="0" rx="8" ry="8" width="100%" height="32" />
                </ContentLoader>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Container>
  );
};

export default EmailMarketingLoadingSkeleton;
